import React from "react";
import { useSelector } from "react-redux";

import UsersKanban from "./UsersKanban";
import Team from "./Team";
import { useSearchParams } from "react-router-dom";
import OpenCardDetail from "../../../board/components/Kanban/openCardDetail";

const GroupingBoards = React.memo(() => {
  const [searchParams] = useSearchParams();
  const isChecked = searchParams.get("switch");
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  const users = React.useMemo(
    () => groupingUser.map((item) => item.users).flat(),
    [groupingUser]
  );

  const usersFromParams = searchParams.get("uid")
    ? searchParams
        .get("uid")
        ?.split(",")
        ?.map((user) => ({ user_id: parseInt(user) }))
    : [];

  return (
    <div>
      <OpenCardDetail />
      {isChecked === "true" ? (
        <Team groupingUser={users} />
      ) : (
        groupingUser && users && <UsersKanban users={usersFromParams} />
      )}
    </div>
  );
});

export default GroupingBoards;
